<div class="panel panel-default  mr-xl-25" id="translate" >
	<div class="panel-heading">
		<h1 class="d-block">
			{{ 'recherche_avance' | translate }} :
		</h1>
        <!-- <div class="px-4 d-inline-block">
            <span class="text-secondary my-2 my-sm-0" >
                <input type="checkbox" (click)="changeShs($event)" [checked]="shs" />
                {{ 'SHS' | translate }} -
            </span>
            <span class="text-secondary my-2 my-sm-0'">
                <input type="checkbox" (click)="changeLmg($event)" [checked]="lmg" />
                {{ 'LMG' | translate }}
            </span>
        </div> -->
	</div>
	<div class="panel-body">
		<div class="tz-gallery col-12 py-0">
        <form #f="ngForm" (ngSubmit)="onSearch(f.value)" class="form-inline">   
            <table class="table">
                <tbody>
                    <tr class="row">
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'titre_trad' | translate }} :</label>
                            <input name="titre" ngModel class="form-control form-control-sm w-100" type="text" placeholder="{{ 'term' | translate }}" aria-label="Terme">
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'titre_org' | translate }} :</label>
                            <input name="titre_par" ngModel class="form-control form-control-sm w-100" type="text" placeholder="{{ 'term' | translate }}" aria-label="Terme">
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'auteur_advanced' | translate }} :</label>
                            <input name="auteur" ngModel class="form-control form-control-sm w-100" type="text" placeholder="{{ 'term' | translate }}" aria-label="Terme">
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'sexe_auteur_advanced' | translate }} :</label>
                            <select name="sexe" ngModel class="form-control form-control-sm w-100">
                                <option value="M">{{ 'M' | translate }}</option>
                                <option value="F">{{ 'F' | translate }}</option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'nat_auteur_advanced' | translate }} :</label>
                            <select name="nat" ngModel class="form-control form-control-sm w-100">
                                <option selected value=" ">{{ 'chosepays' | translate }}</option>
                                <option  *ngFor="let y of listnat" value='{{ y.code }}'>
                                    {{ y.natinalite }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'pays_org' | translate }} : </label>
                            <select name="paysedition" ngModel class="form-control form-control-sm w-100">
                                <option selected value=" ">{{ 'chosepays' | translate }}</option>
                                <option  *ngFor="let y of paysedition" value='{{ y.paysedition }}'>
                                    {{ y.paysedition }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'langue_source' | translate }} : </label>
                            <select name="langsource" ngModel class="form-control form-control-sm w-100">
                                <option selected value=" ">{{ 'choselang' | translate }}</option>
                                <option  *ngFor="let y of langueSource" value='{{ y.Langsource }}'>
                                    {{ y.Langsource }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'langue_cible' | translate }} : </label>
                            <select name="langcible" ngModel class="form-control form-control-sm w-100">
                                <option selected value=" ">{{ 'choselang' | translate }}</option>
                                <option  *ngFor="let y of langueCible" value='{{ y.langcible }}'>
                                    {{ y.langcible }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'theme_topo' | translate }} : </label>
                            <select name="themeg" ngModel class="form-control form-control-sm w-100" (change)="getSubtheme($event.target.value)" >
                                <option selected value=" ">{{ 'chosetheme' | translate }}</option>
                                <option  *ngFor="let t of themes" value='{{ t.id }}'>
                                    {{ t.theme }}
                                </option>
                            </select>
                        </td>
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">--></label>
                            <!-- <span class="text-danger" *ngIf="themesel.value!='' && themesel.value!='Choisir un thème' && themesel.value!='أختر الموضوع'">{{ 'chosesubtheme' | translate }}<br /></span> -->
                            <select name="theme" ngModel class="form-control form-control-sm w-100">
                                <option selected value=" ">{{ 'chosesubtheme' | translate }}</option>
                                <option  *ngFor="let t of subthemes" value='{{ t.code }}'>
                                    {{ t.theme }}
                                </option>
                            </select>
                        </td> 
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'annee_edition' | translate }} : {{ 'entre' | translate }}</label>
                            <select name="first"  ngModel class="form-control form-control-sm w-100" (change)="onchangeDate($event.target.value)">
                                <option disabled selected>{{ 'chosedate' | translate }}</option>
                                <option *ngFor="let y of years">{{ y }}</option>
                            </select>
                        </td>
                        <td class="bold col-12 col-xl-6">
                            <label class="text-left">{{ 'et' | translate }}</label>
                            <select name="end" ngModel class="form-control form-control-sm w-100">
                                <option disabled selected>{{ 'chosedate' | translate }}</option>
                                <option *ngFor="let y of years2">{{ y }}</option>
                            </select>
                        </td> 
                    </tr> 
                </tbody>
            </table>
            <button class="btn btn-success" type="submit">{{ 'recherche' | translate }}</button>
            </form>
		</div>
	</div>
</div>


